module.exports = __webpack_public_path__ + "static/media/info-fill.34b31531.svg";